import { UnicodeEntity } from '@mews/enums';
import { LocalizedPercent } from '@mews/framework';
import { ServiceName } from '../../../../../../components/commander-ui';

interface SurchargePercentLabelProps {
    serviceId: string;
    feePercent: number;
}

export const SurchargePercentLabel: React.FC<SurchargePercentLabelProps> = ({ serviceId, feePercent }) => (
    <>
        <ServiceName id={serviceId} />
        {UnicodeEntity.NoBreakSpace}
        <LocalizedPercent percent={feePercent} />
    </>
);
